var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 13.4374L5.03079 12.1035C5.25263 12.0182 5.36355 11.9755 5.46732 11.9198C5.5595 11.8703 5.64737 11.8132 5.73003 11.7491C5.82308 11.6769 5.90711 11.5928 6.07517 11.4248L13.125 4.37495C13.8154 3.68459 13.8154 2.5653 13.125 1.87494C12.4347 1.18459 11.3154 1.18459 10.625 1.87494L3.57518 8.92477C3.40711 9.09284 3.32308 9.17687 3.25087 9.26992C3.18673 9.35257 3.12963 9.44045 3.08015 9.53262C3.02444 9.6364 2.98178 9.74732 2.89646 9.96916L1.5625 13.4374ZM1.5625 13.4374L2.84883 10.093C2.94087 9.85372 2.9869 9.73406 3.06584 9.67925C3.13482 9.63135 3.22019 9.61323 3.30268 9.62899C3.39708 9.64701 3.48774 9.73767 3.66905 9.91898L5.08098 11.3309C5.2623 11.5122 5.35295 11.6029 5.37098 11.6973C5.38673 11.7798 5.36862 11.8651 5.32072 11.9341C5.2659 12.0131 5.14624 12.0591 4.90692 12.1511L1.5625 13.4374Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.0b8a64e6ca09b4ddcc67a9833ee9b196.svg";
export { ForwardRef as ReactComponent };